import React, { Fragment } from 'react';

import Modal from '../../common/Modal';
import medicationLists from './MedicationListModalData';

function MedicationListModal({ visible, toggleModal, list = 'premix' }) {
  return (
    <Modal
      toggleModal={toggleModal}
      visible={visible}
      centered
    >
      <Fragment>
        <div className="text">
          <h2>
            {medicationLists.text[list].title || ''}
          </h2>
          {(list === 'premix' || list === 'compounding') && (
            <ul className="modal__left-text">
              {medicationLists.lists[list].map(medication => (
                <li key={medication}>{medication}</li>
              ))}
            </ul>
          )}
          {list === 'syringes' && (
            <Fragment>
              {medicationLists.lists[list].map(obj => (
                <Fragment key={obj.heading}>
                  <h3 className="modal__left-text">{obj.heading}</h3>
                  <ul className="modal__left-text">
                    {obj.contents.map(medication => (
                      <li key={medication}>{medication}</li>
                    ))}
                  </ul>
                </Fragment>
              ))}
            </Fragment>
          )}
        </div>
      </Fragment>
    </Modal>
  );
}

export default MedicationListModal;



// WEBPACK FOOTER //
// ./src/components/features/assessment/MedicationListModal.js